import React from "react";
import { FormattedMessage } from "react-intl";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";

import { Substitution } from "../../../../api/types/substitutions";
import { useDeleteSubstitution } from "../../api/useDeleteSubstitution";

type Props = {
  open: boolean;
  onClose: () => void;
  substitution: Substitution | null;
  datasetId?: number;
};

export function DeleteSubstitutionModal({
  open,
  onClose,
  substitution,
  datasetId,
}: Props) {
  const { deleteSubstitution, isPending } = useDeleteSubstitution(datasetId);

  const handleDelete = () => {
    if (!substitution?.Id) return;
    deleteSubstitution(substitution.Id);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <FormattedMessage
          id="SUBSTITUTIONS.DELETE_TITLE"
          defaultMessage="Delete substitution"
        />
      </DialogTitle>
      <DialogContent>
        <FormattedMessage
          id="SUBSTITUTIONS.DELETE_CONFIRM"
          defaultMessage="Are you sure you want to delete this entry?"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          <FormattedMessage id="APP.CANCEL" defaultMessage="Cancel" />
        </Button>
        <Button
          onClick={handleDelete}
          color="error"
          variant="contained"
          disabled={isPending}>
          <FormattedMessage id="APP.DELETE" defaultMessage="Delete" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}
